export default "__VITE_ASSET__63749ddd__"